import React from 'react';
import store from '../store';
import FloatButton from '../components/FloatButton';
//import CardContent from '../components/CardContent';
import Toolbar from '../components/Toolbar';
import DialogCourse from '../components/DialogCourse';
import CardPracticeGuest from '../components/CardPracticeGuest';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import  FormControl  from '@material-ui/core/FormControl';
import Button  from '@material-ui/core/Button';
import Input from '@material-ui/core/Input';
import Grid from '@material-ui/core/Grid';
import GroupWorkIcon from '@material-ui/icons/Group';
import ReceiptIcon from '@material-ui/icons/Receipt';
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";
import { FIREBASE } from "../config/firebase";
import Divider from '@material-ui/core/Divider';
import { Redirect } from 'react-router-dom';
import AllInboxIcon from '@material-ui/icons/AllInbox';
import AddIcon from '@material-ui/icons/Add';
import { NotificationManager} from 'react-notifications';
const DWIDTH = 640;
if (!firebase.apps.length) {
  firebase.initializeApp(FIREBASE);
}
const styles = theme => ({
    title: {
        marginBottom: theme.spacing.unit * 2,
        padding: 0
    },
    search: {
        backgroundColor: '#fff',
        padding: theme.spacing.unit,
        paddingLeft: theme.spacing.unit * 2,
        borderRight: 'solid 1px #ededed',
        borderLeft: 'solid 1px #ededed',
        borderTop: 'solid 1px #ededed'
    },
    buttonAdd: {
        margin: theme.spacing.unit,
        position: 'fixed',
        bottom: theme.spacing.unit * 2,
        right: theme.spacing.unit * 2,
    },
});

function a(q, f) {
    try {
        if (q.toLowerCase().includes(f)) {
            return true;
        } else {
            return false;
        }
    } catch (e) {
        return false;
    }
}


class AdminStudent extends React.Component {
    constructor() {
        super();
        this.state = { search: '',contents:[],open:false,practice:false,student:null};

    }
    loadContents(){
      console.log('load Contents');
      let _this = this;
      let sub = firebase.firestore().collection('courses').orderBy('created','desc').onSnapshot((data)=>{
        let contents = [];
        data.forEach((doc)=>{
          let item = doc.data();
          item.id=doc.id;
          contents.push(item);
        })

        _this.setState({contents});
      })
      _this.setState({sub});
    }
    loadPracticeGuest(){

      let _this = this;
      firebase.firestore().collection('guest').doc('practice').get().then((doc)=>{
        let practice = doc.data();


        _this.setState({practice});
      })
    }
    componentDidMount(){
      //this.loadContents();
      this.loadPracticeGuest();
    }
    componentWillUnmount(){
      if(this.state.sub)
      this.state.sub();
    }
    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };
    handleClose = value => {
        this.setState({ open: false });
    };
    handleClickOpen = () => {
            this.setState({
                open: true,
            });
        };

      handleSearch = async() => {
        let _this = this;
        let search = _this.state.search;
        if(!search||search.trim().length==0)
        {
          NotificationManager.error("Please enter id");
          return;
        }
      //  NotificationManager.error(_this.state.search);
        let doc = await firebase.firestore().collection('data_students').doc('data_students-'+search).get();
        if(doc.exists)
        {
          let student = doc.data();
          _this.setState({student});
        }
        else {
            NotificationManager.error("Not found");
        }

      }
      handleClear = async() => {
        var check = window.confirm("Do you want to clear practice progress for this student?");

        let student = this.state.student;
        if (check === true) {

            let data = await firebase.firestore().collection("data_students").doc('data_students-'+student.id).collection("lastdays").get();
            if(data.size>0)
            {
              console.log(data.size);
              data.forEach(doc=>{
                console.log(doc.id)
                 firebase.firestore().collection("data_students").doc('data_students-'+student.id).collection("lastdays").doc(doc.id).delete();
              })
            }
            NotificationManager.success("Success");
        }
      }

    render() {
        const { classes } = this.props;
        const { search,contents,student } = this.state;

        const item_button =  { name:"", startDate: '',endDate:'',week:4,course_id:0,created:(new Date()).getTime() };
        if(!store.getState().ADMINACCOUNT)
        {
          console.log('No Admin');
          return <Redirect to='/sbadmin' />
        }
        return (
          <div>
          <Toolbar/>
            <div style={{ maxWidth: '720px',margin: '20px auto',paddingTop: '64px'}}>
                <Grid justify="flex-start" direction="row" container>
                    <Grid item><AllInboxIcon style={{ marginRight: 10 }} /></Grid>
                    <Grid item><Typography variant="title" className={classes.title}>Student</Typography></Grid>
                </Grid>



                <FormControl  fullWidth>
                    <Input
                        value={this.state.search}
                        onChange={this.handleChange('search')}
                        type="text"
                        placeholder="Search By Id - ex: 123456"
                        className={classes.search}
                    />
                </FormControl>
                <Button onClick={this.handleSearch} style={{ marginBottom: 30 }} variant="contained" color="secondary" aria-label="add">
                    Search
                </Button>
                {student!=null&&<div>
                  <h2>{student.ten} - {student.mahs}</h2>
                    <Button onClick={this.handleClear} variant="contained" color="primary" aria-label="add">
                        Clear Practice
                    </Button>
                </div>}
                <div style={{ height: 100, display: 'block' }} />

                </div>

            </div>
        )
    }
}

AdminStudent.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AdminStudent);
